<main>
  <div *ngIf="!viewMode">
    <div class="eventList-head flex-wrap gap-2 flex-wrap">
      <div
        class="d-flex align-items-center gap-3"
        style="cursor: pointer"
        (click)="goBack()"
      >
        <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
        <div class="header-text eventList-text">Events</div>
      </div>
      <div class="d-flex gap-3 flex-wrap justify-content-end">
        <div class="search-container" *ngIf="!eventViewMode">
          <div class="search-icon">
            <img
              src="assets/icons/side-bar/search-normal.svg"
              alt="search"
              style="width: 18px; height: 18px"
            />
          </div>
          <input
            type="text"
            placeholder="Search here..."
            class="search-input"
            [(ngModel)]="search"
            (input)="updateSearch(search)"
            (keyup.enter)="applyFilter()"
            autocomplete="off"
          />
        </div>
        <app-button
          [label]="eventViewMode ? 'List view' : 'Calendar view'"
          [minWidth]="'10rem'"
          context="none"
          (click)="eventView()"
        ></app-button>
        <app-button
          label="Create event"
          [minWidth]="'10rem'"
          (clicked)="openAddDialog()"
        ></app-button>

        <app-export-dropdown
          label="Export"
          *ngIf="userRoles?.export && !eventViewMode"
          [apiWise]="true"
          [exportApiUrl]="getExportApiUrl()"
          [tableName]="getTableSegment()"
          [currentParams]="currentExportParams"
          [isSearch]="isSearchExport"
          (export)="onExportClick($event)"
        >
        </app-export-dropdown>
      </div>
    </div>
    <div class="table-details-page" *ngIf="!eventViewMode">
      <div class="table-card">
        <div class="event-segment">
          <button
            [disabled]="tableSegment === 'admin'"
            [ngClass]="{ active: tableSegment === 'admin' }"
            [attr.aria-pressed]="tableSegment === 'admin'"
            (click)="toggleTabs('admin')"
          >
            CSQ events
          </button>

          <button
            [disabled]="tableSegment === 'teacher'"
            [ngClass]="{ active: tableSegment === 'teacher' }"
            (click)="toggleTabs('teacher')"
          >
            Teacher-created work experience
          </button>

          <button
            [disabled]="tableSegment === 'student'"
            [ngClass]="{ active: tableSegment === 'student' }"
            (click)="toggleTabs('student')"
          >
            Student-submitted work experience
          </button>

          <button
            *ngIf="isSuperAdmin"
            [disabled]="tableSegment === 'archived'"
            [ngClass]="{ active: tableSegment === 'archived', 'archived-tab': true }"
            [attr.aria-pressed]="tableSegment === 'archived'"
            (click)="toggleTabs('archived')"
          >
            Archived
          </button>
        </div>

        <app-table
          [columns]="
            tableSegment === 'admin' || tableSegment === 'archived'
              ? columns
              : tableSegment === 'teacher'
                ? secondaryColumn
                : externalColumn
          "
          [data]="tableEvents"
          [loading]="tableLoading"
          [actionTemplate]="actionButtons"
          (rowClick)="onView($event)"
          [tableName]="getTableSegment()"
          (approvalStatusClick)="onStatusClick($event, false)"
          [totalItems]="totalRecords"
          [currentPage]="currentPage"
          [pageSize]="pageSize"
          [sortColumn]="sortColumn"
          [sortDirection]="sortDirection"
          (pageChange)="onPageChange($event)"
          (sortClick)="onSort($event)"
          [serverSidePagination]="true"
        ></app-table>
      </div>
    </div>

    <div class="table-details" *ngIf="eventViewMode">
      <app-event-calendar></app-event-calendar>
    </div>
  </div>

  <div class="d-flex flex-column gap-3" *ngIf="viewMode">
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="goBack()"
      >
        <img
          class="action-button"
          src="assets/images/Buttons/left-chevron.svg"
          alt="left"
        />
        <div class="header-text eventList-text">Back to event list</div>
      </div>

      <div class="d-flex gap-3 flex-wrap" *ngIf="!teacherMode && !pageloading">
        <button
          *ngIf="
            adminViewEvent &&
            (selectedEvent?.eventStatus == 'Upcoming' ||
              selectedEvent?.eventStatus == 'Ongoing')
          "
          class="custom-button"
          (click)="openSendEmail()"
        >
          <img class="upload-icon" src="assets/images/sms.svg" /> Share Email
        </button>
      </div>

      <div
        *ngIf="
          !pageloading &&
          teacherMode &&
          ((adminViewEvent &&
            selectedEvent?.eventStatus !== 'Already Held' &&
            selectedEvent?.eventStatus !== 'On Hold') ||
            ((teacherViewEvent ||
              selectedEvent?.createdByRole == 'super admin') &&
              selectedEvent?.eventAdminApprovalStatusName === 'Approved' &&
              selectedEvent?.eventStatus !== 'Already Held' &&
              selectedEvent?.eventStatus !== 'On Hold') ||
            (studentViewEvent &&
              selectedEvent?.eventAdminApprovalStatusName === 'Approved' &&
              selectedEvent?.eventStatus !== 'Already Held' &&
              selectedEvent?.eventStatus !== 'On Hold'))
        "
      >
        <button class="custom-button" (click)="shareStudent()">
          <img class="upload-icon" src="assets/images/share-icon.svg" />
          {{
            shareLoading ? "Sharing with students..." : "Share with students"
          }}
        </button>
      </div>
    </div>

    <div class="loader" *ngIf="pageloading">
      <div class="spinner"></div>
    </div>

    <div class="d-grid gap-3" *ngIf="!pageloading">
      <div class="school-details" *ngIf="selectedEvent && !teacherMode">
        <div class="event-view-layout">
          <img class="event-image"
            src={{selectedEvent?.eventTypeImage}}
          />

          <div class="w-100 d-grid h-100">
            <div>
              <div class="d-flex justify-content-between flex-wrap gap-3">
                <div class="text-head">{{ selectedEvent.eventName }}</div>

                <div class="d-flex align-items-start gap-2">
                  <div
                    *ngIf="selectedEvent?.isSyncedWithAsana"
                    class="asana-synced"
                  >
                    <div class="asana-synced-item active">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.75 6.75C12.75 10.0637 10.0637 12.75 6.75 12.75C3.43629 12.75 0.75 10.0637 0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75C7.69137 0.75 8.5821 0.966792 9.375 1.35317M11.625 3L6.375 8.25L4.875 6.75"
                          stroke="#3FAD46"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Synced with asana
                    </div>
                    <p>
                      {{
                        selectedEvent?.asanaLastSyncedAt
                          | brisbaneDate: "MMM d y, h:mm a"
                      }}
                      by {{ selectedEvent?.asanaSyncedByUserName }}
                    </p>
                  </div>

                  <div class="d-grid gap-1 align-items-center status-text">
                    Event status
                    <div class="status-dropdown-container">
                      <div
                        class="status-display"
                        [ngClass]="getStatusClass(selectedEvent?.eventStatus)"
                        [style.cursor]="
                          canChangeSelectedEventStatus() ? 'pointer' : 'default'
                        "
                        (click)="
                          canChangeSelectedEventStatus() &&
                            toggleStatusDropdown($event)
                        "
                      >
                        {{ getStatusDisplayValue(selectedEvent?.eventStatus) }}
                        <img
                          *ngIf="canChangeSelectedEventStatus()"
                          src="assets/images/Buttons/arrow.svg"
                          class="dropdown-arrow"
                          [class.rotated]="!showStatusDropdown"
                        />
                      </div>

                      <div
                        class="status-dropdown-menu"
                        [class.show]="showStatusDropdown"
                        (click)="$event.stopPropagation()"
                      >
                        <div
                          *ngIf="statusOptions.length > 0; else loadingStatus"
                        >
                          <div
                            *ngFor="let status of statusOptions"
                            class="status-option"
                            [ngClass]="[
                              getStatusOptionClass(status.label || status.value),
                              selectedEvent?.eventStatus === status.value
                                ? 'active'
                                : '',
                              approvalStatusLoading ? 'loading' : '',
                            ]"
                            (click)="updateEventStatus(status.value)"
                          >
                            {{ status.label }}
                          </div>
                        </div>
                        <ng-template #loadingStatus>
                          <div class="status-option">Loading...</div>
                        </ng-template>
                      </div>

                      <div
                        class="status-backdrop"
                        *ngIf="showStatusDropdown"
                        (click)="closeStatusDropdown()"
                      ></div>
                    </div>
                  </div>
                  
                  <div>
                    <div
                      class="blue-text"
                      (click)="onEdit(selectedEvent)"
                      *ngIf="
                        !isInternal &&
                        canEditEvent(selectedEvent) &&
                        !studentViewEvent &&
                        !teacherViewEvent
                      "
                    >
                      <img
                        class="action-button"
                        src="assets/images/Buttons/edit-button.svg"
                        alt="Edit"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="event-description">
                {{ selectedEvent?.description }}
              </div>
            </div>

            <div class="event-layout" style="margin-top: 20px">
              <div
                *ngIf="!isInternal"
                class="d-flex gap-2 align-items-center primary-text"
              >
                Event type :
                <div class="secondary-text">
                  {{ selectedEvent?.eventTypeName }}
                </div>
              </div>
              <div class="d-flex gap-2 align-items-center primary-text">
                Date :
                <div class="secondary-text">
                  {{ selectedEvent?.eventStartDate | brisbaneDate: "dd-MM-yyyy" }}
                  -
                  {{ selectedEvent?.eventEndDate | brisbaneDate: "dd-MM-yyyy" }}
                </div>
              </div>

              <div></div>
            </div>

            <div class="event-layout" style="margin-top: 20px">
              <div class="d-flex gap-2 align-items-center primary-text">
                Location :
                <div class="secondary-text">{{ selectedEvent?.location }}</div>
              </div>

              <div>
                <div
                  class="d-flex gap-2 align-items-center primary-text"
                  *ngIf="selectedEvent?.eventTime"
                >
                  Time :
                  <div class="secondary-text">
                    {{ selectedEvent?.eventTime }}
                  </div>
                </div>
              </div>
            </div>

            <div style="margin-top: 20px" *ngIf="studentViewEvent">
              <div class="d-flex gap-2 align-items-center primary-text">
                Employer name :
                <div class="secondary-text">
                  {{ selectedEvent?.employerName }}
                </div>
              </div>
            </div>

            <div
              class="d-flex justify-content-end pt-2"
              *ngIf="
                selectedSegment === 'teachers' || selectedSegment === 'students'
              "
            >
              <div
                class="media-download"
                *ngIf="selectedEvent?.imagePaths?.length > 0 && !adminViewEvent"
              >
                <div class="time">
                  <div
                    *ngIf="getEventImage() && !isPdf()"
                    style="max-width: 200px"
                    class="d-flex gap-2 align-items-center px-2"
                    (click)="downloadFiles()"
                  >
                    <img
                      class="download-icon"
                      style="filter: brightness(5); width: 20px; height: 20px"
                      src="assets/images/Buttons/view-button.svg"
                      alt="download"
                    />
                    View evidence
                  </div>

                  <div
                    *ngIf="getEventImage() && isPdf()"
                    style="max-width: 200px"
                    class="d-flex gap-2 align-items-center px-2"
                    (click)="downloadFiles()"
                  >
                    <img
                      class="download-icon"
                      src="assets/images/download-icon.svg"
                      alt="download"
                    />
                    Download evidence
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="school-details"
        *ngIf="selectedEvent && teacherMode && adminViewEvent"
      >
        <div class="event-view-layout">
          <div class="w-100 d-grid h-100">
            <div>
              <div class="d-flex justify-content-between flex-wrap gap-3">
                <div class="text-head">{{ selectedEvent.eventName }}</div>

                <div class="d-flex align-items-center gap-2">
                  <div
                    *ngIf="selectedEvent?.isSyncedWithAsana"
                    class="asana-synced"
                  >
                    <div class="asana-synced-item active">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.75 6.75C12.75 10.0637 10.0637 12.75 6.75 12.75C3.43629 12.75 0.75 10.0637 0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75C7.69137 0.75 8.5821 0.966792 9.375 1.35317M11.625 3L6.375 8.25L4.875 6.75"
                          stroke="#3FAD46"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Synced with asana
                    </div>
                    <p>
                      {{
                        selectedEvent?.asanaLastSyncedAt
                          | brisbaneDate: "MMM d y, h:mm a"
                      }}
                      by {{ selectedEvent?.asanaSyncedByUserName }}
                    </p>
                  </div>

                  <div class="d-flex gap-3 align-items-center status-text">
                    Status :
                    <div class="status-dropdown-container">
                      <div
                        class="status-display"
                        [ngClass]="getStatusClass(selectedEvent?.eventStatus)"
                        [style.cursor]="'default'"
                      >
                        {{ getStatusDisplayValue(selectedEvent?.eventStatus) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="event-description">
                {{ selectedEvent?.description }}
              </div>
            </div>

            <div class="event-layout">
              <div
                *ngIf="!isInternal"
                class="d-flex gap-2 align-items-center primary-text"
              >
                Event type :
                <div class="secondary-text">
                  {{ selectedEvent?.eventTypeName }}
                </div>
              </div>
              <div class="d-flex gap-2 align-items-center primary-text">
                Date :
                <div class="secondary-text">
                  {{ selectedEvent?.eventStartDate | brisbaneDate: "dd-MM-yyyy" }}
                  -
                  {{ selectedEvent?.eventEndDate | brisbaneDate: "dd-MM-yyyy" }}
                </div>
              </div>

              <div class="d-flex gap-2 align-items-center primary-text">
              </div>
            </div>

            <div class="event-layout" style="margin-top: 20px">
              <div class="d-flex gap-2 align-items-center primary-text">
                Location :
                <div class="secondary-text">{{ selectedEvent?.location }}</div>
              </div>
              <div
                class="d-flex gap-2 align-items-center primary-text"
                *ngIf="selectedEvent?.eventTime"
              >
                Time :
                <div class="secondary-text">{{ selectedEvent?.eventTime }}</div>
              </div>
              <div class="d-flex justify-content-end" *ngIf="!adminViewEvent">
                <div
                  class="media-download"
                  *ngIf="selectedEvent?.imagePaths?.length > 0"
                >
                  <div class="time">
                    <div
                      class="d-flex gap-2 align-items-center px-2"
                      (click)="downloadFiles()"
                    >
                      <img
                        class="download-icon"
                        src="assets/images/download-icon.svg"
                        alt="download"
                      />
                      Download
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="school-details"
        *ngIf="selectedEvent && teacherMode && !adminViewEvent"
      >
        <div class="event-view-layout">
          <div class="w-100 d-grid h-100 gap-3">
            <div class="teacher-layout flex-wrap">
              <div class="d-grid">
                <div class="d-flex justify-content-between">
                  <div class="text-head">{{ selectedEvent.eventName }}</div>
                </div>
                <div class="event-description">
                  {{ selectedEvent?.description }}
                </div>
              </div>
              <div
                class="d-flex gap-3 align-items-start work-experience-count"
                *ngIf="!studentEventView"
              >
                <div class="teacher-card tbg-blue w-100">
                  <div class="teacher-primary-text">Total registrations</div>
                  <div class="teacher-secondary-text">
                    {{ engagementMetrics?.totalRegistrations }}
                  </div>
                </div>
                <div class="teacher-card w-100">
                  <div class="teacher-primary-text">Total attendees</div>
                  <div class="teacher-secondary-text">
                    {{ engagementMetrics?.totalAttendees }}
                  </div>
                </div>
                <div class="teacher-card w-100">
                  <div class="teacher-primary-text">Conversion</div>
                  <div class="teacher-secondary-text">
                    {{ engagementMetrics?.conversionRate }}%
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="!teacherMode">
              <div class="teacher-event-layout">
                <div class="d-flex gap-2 align-items-center primary-text">
                  Event type :
                  <div class="secondary-text">
                    {{ selectedEvent?.eventTypeName }}
                  </div>
                </div>
                <div class="d-flex gap-2 align-items-center primary-text">
                  Date :
                  <div class="secondary-text">
                    {{ selectedEvent?.eventStartDate | brisbaneDate: "dd-MM-yyyy" }}
                    -
                    {{ selectedEvent?.eventEndDate | brisbaneDate: "dd-MM-yyyy" }}
                  </div>
                </div>
                <div class="d-flex gap-2 align-items-center primary-text">
                </div>
              </div>

              <div class="teacher-event-layout">
                <div class="d-flex gap-2 align-items-center primary-text">
                  Location :
                  <div class="secondary-text">
                    {{ selectedEvent?.location }}
                  </div>
                </div>
                <div class="d-flex gap-2 align-items-center primary-text">
                  <div *ngIf="selectedEvent?.eventTime">
                    Time :
                    <div class="secondary-text">
                      {{ selectedEvent?.eventTime }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="teacher-event-layout">
                <div class="d-flex gap-2 align-items-center primary-text">
                  Event managers :
                  <div class="secondary-text">{{ getManagersNames() }}</div>
                </div>
                <div class="d-flex gap-2 align-items-center primary-text">
                  Status :
                  <div class="secondary-text">
                    <div class="secondary-text status-dropdown-wrapper">
                      <div
                        class="status-display"
                        [ngClass]="getStatusClass(selectedEvent?.eventStatus)"
                        [style.cursor]="
                          canChangeSelectedEventStatus() ? 'pointer' : 'default'
                        "
                        (click)="
                          canChangeSelectedEventStatus() &&
                            toggleStatusDropdown($event)
                        "
                      >
                        {{ getStatusDisplayValue(selectedEvent?.eventStatus) }}
                        <img
                          *ngIf="canChangeSelectedEventStatus()"
                          src="assets/images/Buttons/arrow.svg"
                          class="dropdown-arrow"
                          [class.rotated]="!showStatusDropdown"
                        />
                      </div>

                      <div
                        class="status-dropdown-menu"
                        [class.show]="showStatusDropdown"
                        (click)="$event.stopPropagation()"
                      >
                        <div
                          *ngIf="
                            teacherStatusOption.length > 0;
                            else loadingTeacherStatus
                          "
                        >
                          <div
                            *ngFor="let status of teacherStatusOption"
                            class="status-option"
                            [class.active]="
                              selectedEvent?.eventStatus === status.value
                            "
                            [class.loading]="approvalStatusLoading"
                            (click)="updateEventStatus(status.value)"
                          >
                            {{ status.label }}
                          </div>
                        </div>
                        <ng-template #loadingTeacherStatus>
                          <div class="status-option">Loading status...</div>
                        </ng-template>
                      </div>

                      <div
                        class="status-backdrop"
                        *ngIf="showStatusDropdown"
                        (click)="closeStatusDropdown()"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="teacherMode">
              <div class="teacher-event-layout">
                <div class="d-flex gap-2 align-items-center primary-text">
                  Location :
                  <div class="secondary-text">
                    {{ selectedEvent?.location }}
                  </div>
                </div>

                <div class="d-flex gap-2 align-items-center primary-text">
                  Date :
                  <div class="secondary-text">
                    {{ selectedEvent?.eventStartDate | brisbaneDate: "dd-MM-yyyy" }}
                    -
                    {{ selectedEvent?.eventEndDate | brisbaneDate: "dd-MM-yyyy" }}
                  </div>
                </div>

                <div class="d-flex gap-2 align-items-center primary-text">
                  Status :
                  <div class="secondary-text">
                    <div class="secondary-text status-dropdown-wrapper">
                      <div
                        class="status-display"
                        [ngClass]="getStatusClass(selectedEvent?.eventStatus)"
                        [style.cursor]="'default'"
                      >
                        {{ getStatusDisplayValue(selectedEvent?.eventStatus) }}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="studentViewEvent"
                  class="d-flex gap-3 align-items-center status-text"
                >
                  Teacher approval status :
                  <div class="status-dropdown-container">
                    <div
                      class="status-display"
                      [ngClass]="
                        getApprovalStatusClass(
                          selectedEvent?.eventTeacherApprovalStatusName,
                          true
                        )
                      "
                      (click)="toggleApprovalStatusDropdown($event)"
                    >
                      <span
                        *ngIf="
                          teacherApprovalStatusLoading &&
                          teacherApprovalStatusLoadingText
                        "
                      >
                        {{ getTeacherApprovalStatusLoadingText() }}
                      </span>
                      <span
                        *ngIf="
                          !teacherApprovalStatusLoading ||
                          !teacherApprovalStatusLoadingText
                        "
                      >
                        {{ selectedEvent?.eventTeacherApprovalStatusName }}
                      </span>

                      <img
                        *ngIf="
                          studentViewEvent && !teacherApprovalStatusLoading
                        "
                        src="assets/images/Buttons/arrow.svg"
                        class="dropdown-arrow"
                        [class.rotated]="!showApprovalStatusDropdown"
                      />
                    </div>

                    <div
                      class="status-dropdown-menu"
                      *ngIf="studentViewEvent"
                      [class.show]="showApprovalStatusDropdown"
                      (click)="$event.stopPropagation()"
                    >
                      <div
                        *ngIf="
                          !teacherApprovalStatusLoading;
                          else loadingTemplate
                        "
                      >
                        <div
                          *ngFor="let status of approveStatusOptions"
                          class="status-option"
                          [class.active]="
                            selectedEvent?.eventStatus === status.value
                          "
                          (click)="updateApprovalStatus(status.value)"
                        >
                          {{ status.label }}
                        </div>
                      </div>
                      <ng-template #loadingTemplate>
                        <div class="status-option loading">Updating...</div>
                      </ng-template>
                    </div>

                    <div
                      class="status-backdrop"
                      *ngIf="showApprovalStatusDropdown"
                      (click)="closeStatusDropdown()"
                    ></div>
                  </div>
                </div>

                <div
                  *ngIf="studentViewEvent || teacherViewEvent"
                  class="d-flex gap-3 align-items-center status-text"
                >
                  Admin approval status :
                  <div class="status-dropdown-container">
                    <div
                      class="status-display"
                      [ngClass]="
                        getApprovalStatusClass(
                          selectedEvent?.eventAdminApprovalStatusName
                        )
                      "
                      [style.cursor]="'default'"
                    >
                      {{ selectedEvent?.eventAdminApprovalStatusName }}
                    </div>
                  </div>
                </div>

                <div class="mt-1" *ngIf="studentViewEvent">
                  <div class="d-flex gap-2 align-items-center primary-text">
                    Employer name :
                    <div class="secondary-text">
                      {{ selectedEvent?.employerName }}
                    </div>
                  </div>
                </div>

                <div class="teacher-event-layout">
                  <div
                    class="d-flex gap-2 align-items-center primary-text"
                    *ngIf="selectedEvent?.eventTime"
                  >
                    Time :
                    <div class="secondary-text">
                      {{ selectedEvent?.eventTime }}
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-end pt-2">
                  <div
                    class="media-download"
                    *ngIf="
                      selectedEvent?.imagePaths?.length > 0 && !adminViewEvent
                    "
                  >
                    <div class="time">
                      <div
                        *ngIf="getEventImage() && !isPdf()"
                        style="max-width: 200px"
                        class="d-flex gap-2 align-items-center px-2"
                        (click)="downloadFiles()"
                      >
                        <img
                          class="download-icon"
                          style="
                            filter: brightness(5);
                            width: 20px;
                            height: 20px;
                          "
                          src="assets/images/Buttons/view-button.svg"
                          alt="download"
                        />
                        View evidence
                      </div>

                      <div
                        *ngIf="getEventImage() && isPdf()"
                        style="max-width: 200px"
                        class="d-flex gap-2 align-items-center px-2"
                        (click)="downloadFiles()"
                      >
                        <img
                          class="download-icon"
                          src="assets/images/download-icon.svg"
                          alt="download"
                        />
                        Evidence
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="d-flex gap-2 justify-content-between align-items-start"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="second-container flex-wrap"
        [ngClass]="
          !teacherViewEvent && !studentViewEvent ? 'isInternal' : 'not-internal'
        "
        *ngIf="selectedEvent && !teacherMode && !studentEventView"
      >
        <div class="d-flex gap-3 flex-column w-100">
          <div
            class="d-flex justify-content-between gap-2 three-items-container"
          >
            <div class="total-card total-card-active">
              <span class="secondary-text teacher-primary-text"
                >Total registrations</span
              >
              <span class="primary-text teacher-secondary-text">{{
                engagementMetrics?.totalRegistrations
              }}</span>
            </div>

            <div class="total-card">
              <span class="secondary-text teacher-primary-text"
                >Total attendees</span
              >
              <span class="primary-text teacher-secondary-text">{{
                engagementMetrics?.totalAttendees
              }}</span>
            </div>

            <div class="total-card">
              <span class="secondary-text teacher-primary-text"
                >Conversion</span
              >
              <span class="primary-text teacher-secondary-text"
                >{{ engagementMetrics?.conversionRate }}%</span
              >
            </div>
          </div>
          <div
            class="chart-details-card"
            style="align-items: unset"
            *ngIf="!studentViewEvent && !teacherViewEvent"
          >
            <div class="d-grid gap-3">
              <div class="d-flex gap-2 align-items-center primary-text">
                Focus area :
                <div class="secondary-text">
                  {{ getFocusAreaNames() }}
                </div>
              </div>
              <div class="d-flex gap-2 align-items-center primary-text">
                Audience :
                <div class="secondary-text">
                  {{ selectedEvent?.audienceTypeName }}
                </div>
              </div>
              <div class="d-flex gap-2 align-items-center primary-text">
                Region :
                <div class="secondary-text">
                  {{ selectedEvent?.eventHostRegionName }}
                </div>
              </div>
              <div class="d-flex gap-2 align-items-center primary-text">
                Event managers :
                <div class="secondary-text">{{ getManagersNames() }}</div>
              </div>
              <div class="d-flex gap-2 align-items-center primary-text">
                Industry Partners :
                <div class="secondary-text">
                  {{ getMCCpartnersNames() }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="chart-wrapper" *ngIf="viewMode">
          <h3 class="chart-title">Registration over time</h3>
          <div
            *ngIf="
              chartData &&
                chartData.length > 0 &&
                chartData[0]?.date !== 'No Data';
              else noChartData
            "
          >
            <div #chartContainer class="chart-container"></div>
          </div>

          <ng-template #noChartData>
            <div class="no-data-message">
              <p>No registration data available for this event</p>
            </div>
          </ng-template>
        </div>
      </div>

      <div
        [ngClass]="!isInternal ? 'isInternal' : 'not-internal'"
        *ngIf="selectedEvent && teacherMode && adminViewEvent"
      >
        <div class="d-flex gap-3 flex-column">
          <div
            class="d-flex justify-content-between gap-3 work-experience-count-teacher"
          >
            <div class="total-card total-card-active w-100">
              <span class="secondary-text teacher-primary-text"
                >Total registrations</span
              >
              <span class="primary-text teacher-secondary-text">{{
                engagementMetrics?.totalRegistrations
              }}</span>
            </div>

            <div class="total-card w-100">
              <span class="secondary-text teacher-primary-text"
                >Total attendees</span
              >
              <span class="primary-text teacher-secondary-text">{{
                engagementMetrics?.totalAttendees
              }}</span>
            </div>

            <div class="total-card w-100">
              <span class="secondary-text teacher-primary-text"
                >Conversion</span
              >
              <span class="primary-text teacher-secondary-text"
                >{{ engagementMetrics?.conversionRate }}%</span
              >
            </div>
          </div>

          <div class="chart-details-card" *ngIf="!isInternal">
            <div class="tchadmview">
              <div class="d-flex gap-2 align-items-center primary-text">
                Focus area :
                <div class="secondary-text">
                  {{ getFocusAreaNames() }}
                </div>
              </div>
              <div class="d-flex gap-2 align-items-center primary-text">
                Audience :
                <div class="secondary-text">
                  {{ selectedEvent?.audienceTypeName }}
                </div>
              </div>
              <div
                class="d-flex gap-2 align-items-center primary-text justify-content-center"
              >
                Region :
                <div class="secondary-text">
                  {{ selectedEvent?.eventHostRegionName }}
                </div>
              </div>
              <div class="d-flex gap-2 align-items-center primary-text">
                Event managers :
                <div class="secondary-text">{{ getManagersNames() }}</div>
              </div>
              <div class="d-flex gap-2 align-items-center primary-text">
                Industry Partners :
                <div class="secondary-text">
                  {{ getMCCpartnersNames() }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table-details" *ngIf="teacherMode">
        <div class="settings-bg">
          <div
            class="d-flex justify-content-between settings-bg-button flex-wrap"
          >
            <div class="segment-buttons">
              <button
                [class.active]="selectedSegment === 'students'"
                style="cursor: default"
              >
                Students
              </button>
            </div>

            <div class="d-flex">
              <app-export-dropdown
                *ngIf="teacherStudentData && teacherStudentData.length > 0"
                [statusColor]="'#363636'"
                label="Export"
              >
              </app-export-dropdown>

              <div
                class="add-buttons"
                *ngIf="
                  !studentViewEvent &&
                  selectedEvent?.eventAdminApprovalStatusName !== 'Declined' &&
                  selectedEvent?.eventAdminApprovalStatusName !== 'Pending' &&
                  (selectedEvent?.eventStatus == 'Upcoming' ||
                    selectedEvent?.eventStatus == 'Ongoing' ||
                    selectedEvent?.eventStatus == 'Already Held')
                "
              >
                <button
                  *ngIf="selectedSegment === 'students' && !studentViewEvent"
                  (click)="openAddStudentDialog(selectedEvent)"
                >
                  <img
                    src="assets/images/add-icon.svg"
                    alt="plus"
                    class="plus-icon"
                  />
                  Assign student
                </button>
              </div>
            </div>
          </div>

          <div class="table-page">
            <div *ngIf="selectedSegment === 'students'">
              <app-table
                [columns]="selectedColumns"
                [data]="teacherStudentData"
                [loading]="teacherloading"
                [eventStatus]="selectedEvent?.eventStatus"
                (approvalStatusClick)="onStatusClick($event, true)"
                (toggleChange)="onToggleChange($event)"
                (statusClick)="teacherApprovalStatusClick($event)"
                (downloadClick)="onDownloadConsent($event)"
                (noteUpdate)="onNoteUpdate($event)"
              >
              </app-table>
            </div>
          </div>
        </div>
      </div>

      <div class="table-details" *ngIf="!teacherMode">
        <div class="settings-bg">
          <div
            class="d-flex justify-content-between settings-bg-button flex-wrap"
          >
            <div class="segment-buttons">
              <button [class.active]="selectedSegment === 'students'">
                Students
              </button>
            </div>
            <div class="add-buttons">
              <button
                *ngIf="
                  selectedSegment === 'students' &&
                  selectedEvent?.eventAdminApprovalStatusName !== 'Declined' &&
                  selectedEvent?.eventAdminApprovalStatusName !== 'Pending' &&
                  !studentViewEvent &&
                  (selectedEvent?.eventStatus == 'Upcoming' ||
                    selectedEvent?.eventStatus == 'Ongoing' ||
                    selectedEvent?.eventStatus == 'Already Held')
                "
                (click)="openAddStudentDialog(selectedEvent)"
              >
                <img
                  src="assets/images/add-icon.svg"
                  alt="plus"
                  class="plus-icon"
                />
                Assign student
              </button>
            </div>
          </div>

          <div class="table-page">
            <div *ngIf="selectedSegment === 'students'">
              <app-table
                [columns]="selectedColumnsAdmin"
                [data]="eventStudentList"
                [loading]="studentTabelLoading"
                [eventStatus]="selectedEvent?.eventStatus"
                (toggleChange)="onToggleChange($event)"
                (downloadClick)="onDownloadConsent($event)"
                (noteUpdate)="onNoteUpdate($event)"
              >
              </app-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showEventModal" (click)="closeEventModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div></div>
        <button class="close-btn" (click)="closeEventModal()">&times;</button>
      </div>

      <div class="modal-body">
        <img [src]="showEventModal" alt="Event Image" />
      </div>
    </div>
  </div>
</main>

<ng-template #actionButtons let-row>
  <ng-container
    *ngIf="
      userRoles.listItem.view ||
      userRoles.listItem.edit ||
      userRoles.listItem.delete
    "
  >
    <div style="display: flex; gap: 0.8rem; justify-content: center">
      <img
        class="action-button"
        *ngIf="userRoles.listItem.view"
        (click)="onView(row)"
        src="assets/images/Buttons/view-button.svg"
        alt="View"
      />

      <img
        class="action-button"
        *ngIf="canEditEvent(row) && userRoles.listItem.edit"
        (click)="onEdit(row)"
        src="assets/images/Buttons/edit-button.svg"
        alt="Edit"
      />

      <img
        class="action-button"
        *ngIf="canDeleteEvent(row) && userRoles.listItem.delete"
        (click)="onDelete(row)"
        src="assets/images/Buttons/delete-button.svg"
        alt="Delete"
      />
    </div>
  </ng-container>
</ng-template>

<ng-template #actionButtonsStudent let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <img
      class="action-button"
      src="assets/images/Buttons/view-button.svg"
      alt="View"
    />
  </div>
</ng-template>
